import Css from "./style.module.scss";

import Content from "./Content";
import FormContext from "contexts/FormContext";
import Provider from "./Provider";
import React, { useCallback, useContext, useRef } from "react";
import useDocumentUtils from "hooks/useDocumentUtils";

const EditForm = ({ disabled, documentData, documentFrozen, setLoading, fetchData, refetchDocuments }) => {
  const rootRef = useRef(null);

  const { values, values: { paymentType } = {}, setState } = useContext(FormContext);

  const { openPairedTransactionsWindow } = useDocumentUtils();

  const handleDocumentChange = useCallback((update) => {
    setState((state) => {
      const newValues = update(state.values);

      return { ...state, values: { ...state.values, ...newValues } };
    });
  }, [setState]);

  const onOpenPairedTransactionsWindow = useCallback(async() => {
    setLoading(true);

    const result = await openPairedTransactionsWindow({ ...documentData, paymentType });

    if (result) {
      await fetchData();
      if (refetchDocuments) refetchDocuments();
    }
    setLoading(false);
  }, [
    fetchData,
    paymentType,
    documentData,
    openPairedTransactionsWindow,
    refetchDocuments,
    setLoading
  ]);

  const { attachment } = documentData || {};

  return (
    <div className={Css.container}>
      <div ref={rootRef} className={Css.documentLabeler}>
        <Provider
          rootRef={rootRef}
          state={values}
          disabled={disabled}
          attachment={attachment}
          documentData={documentData}
          recogniseData={documentData.recogniseData}
          documentFrozen={documentFrozen}
          refetchDocumentData={fetchData}
          onChange={handleDocumentChange}
          onPairedTransactionClick={onOpenPairedTransactionsWindow} >
          <Content disabled={disabled} />
        </Provider>
      </div>
    </div>
  );
};

export default React.memo(EditForm);
